import script from "./TopCoefficientsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopCoefficientsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopCoefficientsPanel.vue?vue&type=style&index=0&id=68feac30&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68feac30"]])

export default __exports__